import BaseApiService from './BaseApiService'

class AppointmentService extends BaseApiService {
   constructor() {
      super()
   }
   
   async createPaperAppointment(payload) {
      return await super.execute('post','appointment/createPaperAppointment',payload)
   }

   async create(payload) {
      return await super.execute('post', `appointment`, payload)
   }

   async createMulti(payload) {
      return await super.execute('post', `appointment/multi`, payload)
   }

   async save(payload) {
      return await super.execute('put', `appointment`, payload)
   }

   async getAppointments(guid) {
      return await super.execute('get', `appointment/list/${guid}`)
   }

   async findAppointment(payload) {
      return await super.execute('post', `appointment/byagent`, payload)
   }

   async getAppointment(appointmentId) {
      return await super.execute('get', `appointment/${appointmentId}`)
   }

   async getPendingInvites(guid) {
      return await super.execute('get', `appointment/pending/${guid}`)
   }

   async getMultiLink(guid) {
      return await super.execute('get', `appointment/multi/${guid}`)
   }

   async getParentMultiLinkId(appointmentId) {
      return await super.execute('get', `appointment/getParentMultiLinkId/${appointmentId}`)
   }

   async getLinks(payload) {
      return await super.execute('post', `appointment/links`, payload)
   }

   async getLink(linkId) {
      return await super.execute('get', `appointment/link/${linkId}`)
   }
     
   async getLinksByAgent(payload) {
      return await super.execute('post', `appointment/agtlinks`, payload)
   }

   async getCartLinks(payload) {
      return await super.execute('post', `appointment/cartlinks`, payload)
   }

   async validateAppointmentAndLink(payload) {
      return await super.execute('post','appointment/link/validateAppointmentAndLink',payload)
   }

   async sendInvitation(payload) {
      return await super.execute('post', `appointment/invite`, payload)
   }

   async viewInvitations(payload) {
      return await super.execute('post', `appointment/invites`, payload)
   }

   async viewInProgress(payload) {
      return await super.execute('post', `appointment/inprog`, payload)
   }

   async getTemplate(templateId) {
      return await super.execute('get', `corr/template/${templateId}`)
   }

   async getInvite(inviteId) {
      return await super.execute('get', `appointment/invite/${inviteId}`)
   }

   async deleteInvite(link,userid) {
      return await super.execute('delete', `appointment/delinvite/${link}/${userid}`)
   }

   async loadInvitation(payload) {
      return await super.execute('post', `appointment/loadinvite`, payload)
   }

   async getRecruiter(link) {
      return await super.execute('get', `appointment/recruiter/${link}`)
   }

   async getMultiRecruiter(id) {
      return await super.execute('get', `appointment/multirec/${id}`)
   }

   async getFees() {
      return await super.execute('get', `appointment/fees`)
   }

   async getQuestions(questionType) {
      return await super.execute('get', `appointment/questions/${questionType}`)
   }
   async changeApptType(payload) {
      return await super.execute('post', `appointment/appointmentType`, payload)
   }
}

export let apptApi = new AppointmentService()
